/**
 * @file content-schedule.js
 * @description 公開日時を境に JSON の読み出し先を切り替える
 */

import axios from "axios";

/** 公開日時（Asia/Tokyo, "YYYY-MM-DD HH:mm:ss"）。この時刻以降は通常 JSON、未満は *_old.json */
export const PUBLISH_AT = "2026-10-03 10:00:00";

/** サーバー時刻 API（レスポンス: { "Asia/Tokyo": "YYYY-MM-DD HH:mm:ss" }） */
const SERVER_TIME_URL = "https://mxdzmuxhapsr6fea2rrjdobzey0kgeia.lambda-url.ap-northeast-1.on.aws/";

const TOKYO_TIME_KEY = "Asia/Tokyo";

/** "YYYY-MM-DD HH:mm:ss" 形式かどうか */
const TOKYO_TIME_PATTERN = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

/** @type {Promise<boolean> | null} */
let publishedPromise = null;

/**
 * サーバー時刻が公開日時以降かを返す。
 * 取得失敗・形式不正時は未公開（false）として扱う。
 * @returns {Promise<boolean>}
 */
function isPublished() {
  if (!publishedPromise) {
    publishedPromise = (async () => {
      try {
        const res = await axios.get(SERVER_TIME_URL, {
          params: { t: String(Date.now()) },
        });
        const now = res?.data?.[TOKYO_TIME_KEY];
        if (typeof now !== "string" || !TOKYO_TIME_PATTERN.test(now)) {
          console.warn("[schedule] サーバー時刻の形式が不正です。未公開JSONを使用します:", now);
          return false;
        }
        // ゼロ埋めの日時文字列同士なので、ローカルTZに依存せず比較できる
        return now >= PUBLISH_AT;
      } catch (err) {
        console.error("[schedule] サーバー時刻の取得に失敗。未公開JSONを使用します:", err);
        return false;
      }
    })();
  }
  return publishedPromise;
}

/**
 * 公開日時未満なら `foo.json` を `foo_old.json` に差し替える。
 * 時刻取得はモジュール内で1回だけ行い、呼び出し間で共有する。
 * @param {string} url - 例: "./data/goods.json"
 * @returns {Promise<string>}
 */
export async function resolveScheduledJsonUrl(url) {
  const published = await isPublished();
  if (published) return url;
  return url.replace(/\.json$/, "_old.json");
}
